import React from 'react';
import {Row, Col, Card} from 'react-bootstrap';
import {connect} from 'react-redux';
import {getIssuesComponent, getErrorIssues, getWarningIssues} from '../../../../../../../utils/validationSummary';
import {resolveAstroDimChain, getSlotMinExclusive, getSlotMaxExclusive, isNextDay} from '../../../../../../../utils/astroDimTimings';
import {InputTime} from './InputTime';

class PropertyTableTimePickerSens extends React.Component {

    constructor(props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
    }

    isOn(property) {
        return property.value !== undefined
            && property.value !== null
            && property.value !== ''
            && property.value.toUpperCase() !== 'OFF'
            && property.value !== property.valueMeta.off;
    }

    /**
     * Check if a property name matches the given prefix followed by a digit.
     * This prevents false matches like "astdimsens.tv" matching prefix "astdimsens.t".
     */
    matchesPropertyPrefix(propertyName, prefix) {
        if (!propertyName.startsWith(prefix)) return false;
        const suffix = propertyName.substring(prefix.length);
        return suffix.length > 0 && /^\d/.test(suffix);
    }

    handleChange(e) {

        e.preventDefault();

        const value = e.target.value;
        const name = e.target.name;

        // if I am deleting
        if (value === null || value === '') {
            return;
        }

        this.props.handleChange(name, value);
    }

    renderFirstRow(type) {
        // Output Level

        const columns = [];

        if (this.props.displayColors) {
            columns.push(
                <Row style={{margin: this.props.margin}}>
                    <Col sm={7} md={7} lg={7} style={{}} key={`${type}0`}>
                        <input
                            id={`${type}0`}
                            disabled
                            className={'input-property-picker'}
                            name={`${type}0`}
                            type="number"
                            min={0}
                            max={0}
                            value={0}/>
                    </Col>
                    <Col sm={4} md={4} lg={4}>%</Col>
                </Row>
            );
        }

        Object.keys(this.props.properties).sort((a, b) => parseInt(a.replace(/\D+/g, '')) - parseInt(b.replace(/\D+/g, ''))).forEach((key) => {

            if (this.matchesPropertyPrefix(this.props.properties[key].info.name, type)) {
                if (this.props.properties[key].value === 'Off') {
                    this.props.properties[key].value = 0;
                }
                const errors = getErrorIssues(this.props.issues, this.props.properties[key]);
                const warnings = getWarningIssues(this.props.issues, this.props.properties[key]);

                const className = `input-property-picker ${errors.length > 0 ? 'danger' : warnings.length > 0 ? 'warning' : ''}`;

                columns.push(
                    <Row style={{margin: this.props.margin}}>
                        <Col sm={7} md={7} lg={7} style={{}} key={this.props.properties[key].id}>
                            <input
                                id={key}
                                disabled={this.props.disabled}
                                className={className}
                                name={this.props.properties[key].info.name}
                                type="number"
                                min={this.props.properties[key].valueMeta.min}
                                max={this.props.properties[key].valueMeta.max}
                                value={this.props.properties[key].value}
                                onChange={this.handleChange}/>
                            {getIssuesComponent(errors, warnings)}
                        </Col>
                        <Col sm={4} md={4} lg={4}>%</Col>
                    </Row>
                );
            }

        });

        if (this.props.displayColors) {
            columns.push(
                <Row style={{margin: this.props.margin}}>
                    <Col sm={7} md={7} lg={7} style={{}} key={`${type}11`}>
                        <input
                            id={`${type}11`}
                            disabled
                            className={'input-property-picker'}
                            name={`${type}11`}
                            type="number"
                            min={0}
                            max={0}
                            value={0}/>
                    </Col>
                    <Col sm={4} md={4} lg={4}>%</Col>
                </Row>
            );
        }

        return columns;
    }

    renderSecondRow(type) {
        // Time

        const columns = [];
        const submode = this.props.submode;

        // RTC_Based (submode "0") schedules start at 13:00; every other submode starts at 00:00.
        const anchorTime = submode && submode.value === "0" ? '13:00' : '00:00';

        if (this.props.displayColors) {
            columns.push(
                <Row style={{margin: this.props.margin}}>
                    <Col sm={7} md={7} lg={7} key={`${type}0`}>
                        <input
                            id={`${type}0`}
                            disabled
                            className={'input-property-picker'}
                            name={`${type}0`}
                            type="text"
                            min={0}
                            max={0}
                            value={'OFF'}/>
                    </Col>
                    <Col sm={4} md={4} lg={4}>hh:mm</Col>
                </Row>
            );
        }

        columns.push(
            <Row style={{margin: this.props.margin}}>
                <Col sm={7} md={7} lg={7} key={`${type}1`}>
                    <input
                        id={`${type}1`}
                        disabled
                        className={'input-property-picker'}
                        name={`${type}1`}
                        type="text"
                        value={anchorTime}/>
                </Col>
                <Col sm={4} md={4} lg={4}>hh:mm</Col>
            </Row>
        );

        // Collect time property keys in sorted order
        const timeKeys = Object.keys(this.props.properties)
            .sort((a, b) => parseInt(a.replace(/\D+/g, '')) - parseInt(b.replace(/\D+/g, '')))
            .filter((key) => this.matchesPropertyPrefix(this.props.properties[key].info.name, type));

        // Chained min-time enforcement applies to RTC-based ("0") and Time-based ("1") schedules
        // only - SD-triggered ("2") slots aren't user-editable, so no chain is computed there.
        const submodeValue = submode && submode.value;
        const resolvedChain = (submodeValue === "0" || submodeValue === "1")
            ? resolveAstroDimChain(anchorTime, timeKeys.map((key) => this.props.properties[key].value))
            : null;

        timeKeys.forEach((key, index) => {
            const errors = getErrorIssues(this.props.issues, this.props.properties[key]);
            const warnings = getWarningIssues(this.props.issues, this.props.properties[key]);

            const className = `input-property-picker ${errors.length > 0 ? 'danger' : warnings.length > 0 ? 'warning' : ''}`;

            if (this.props.properties[key].info.name === `${type}0` && submode && submode.value === "2") {
                columns.push(
                    <Row style={{margin: this.props.margin}}>
                        <Col sm={7} md={7} lg={7} key={this.props.properties[key].id}>
                            <input
                                id={key}
                                disabled={true}
                                className={className}
                                name={this.props.properties[key].info.name}
                                type="text"
                                min={this.props.properties[key].valueMeta.min}
                                max={this.props.properties[key].valueMeta.max}
                                value={"SD"}
                                onChange={this.handleChange}/>
                            {getIssuesComponent(errors, warnings)}
                        </Col>
                        <Col sm={4} md={4} lg={4}>hh:mm</Col>
                    </Row>
                );
            } else {
                const minExclusive = resolvedChain ? getSlotMinExclusive(anchorTime, resolvedChain, index) : undefined;
                const maxExclusive = resolvedChain ? getSlotMaxExclusive(resolvedChain, index) : undefined;
                const nextDay = resolvedChain ? isNextDay(resolvedChain[index]) : false;
                const colNumbers = nextDay ? 3 : 4;
                columns.push(
                    <Row style={{margin: this.props.margin}}>
                        <Col sm={7} md={7} lg={7} key={this.props.properties[key].id}>
                            <InputTime
                                id={key}
                                disabled={this.props.disabled}
                                className={className}
                                name={this.props.properties[key].info.name}
                                value={this.props.properties[key].value}
                                anchorTime={anchorTime}
                                minExclusive={minExclusive}
                                maxExclusive={maxExclusive}
                                onChange={(value) => value && this.props.handleChange(this.props.properties[key].info.name, value)}/>
                            {getIssuesComponent(errors, warnings)}
                        </Col>
                        <Col sm={colNumbers} md={colNumbers} lg={colNumbers}>hh:mm</Col>
                        {nextDay ?
                            <Col sm={2} md={2} lg={2}>
                                <span className="text-muted" style={{marginLeft: 4, fontSize: '0.75em'}}>+1d</span>
                            </Col>
                            : null
                        }
                    </Row>
                );
            }
        });

        if (this.props.displayColors) {
            columns.push(
                <Row style={{margin: this.props.margin}}>
                    <Col sm={7} md={7} lg={7} key={`${type}11`}>
                        <input
                            id={`${type}11`}
                            disabled
                            className={'input-property-picker'}
                            name={`${type}11`}
                            type="text"
                            value={'OFF'}/>
                    </Col>
                    <Col sm={4} md={4} lg={4}>hh:mm</Col>
                </Row>
            );
        }

        return columns;
    }

    renderThirdRow(type) {
        // Sensor Occupy Level

        const columns = [];

        if (this.props.displayColors) {
            columns.push(
                <Row style={{margin: this.props.margin}}>
                    <Col sm={7} md={7} lg={7} style={{}} key={`${type}0`}>
                        <input
                            id={`${type}0`}
                            disabled
                            className={'input-property-picker'}
                            name={`${type}0`}
                            type="number"
                            min={0}
                            max={0}
                            value={0}/>
                    </Col>
                    <Col sm={4} md={4} lg={4}>%</Col>
                </Row>
            );
        }

        Object.keys(this.props.properties)
            .sort((a, b) =>
                parseInt(a.replace(/\D+/g, '')) - parseInt(b.replace(/\D+/g, ''))
            )
            .forEach((key) => {
                if (this.matchesPropertyPrefix(this.props.properties[key].info.name, type)) {
                    if (this.props.properties[key].value === 'Off') {
                        this.props.properties[key].value = 0;
                    }
                    const errors = getErrorIssues(this.props.issues, this.props.properties[key]);
                    const warnings = getWarningIssues(this.props.issues, this.props.properties[key]);

                    const className = `input-property-picker ${errors.length > 0 ? 'danger' : warnings.length > 0 ? 'warning' : ''}`;

                    columns.push(
                        <Row style={{margin: this.props.margin}}>
                            <Col sm={7} md={7} lg={7} style={{}} key={this.props.properties[key].id}>
                                <input
                                    id={key}
                                    disabled={this.props.disabled}
                                    className={className}
                                    name={this.props.properties[key].info.name}
                                    type="number"
                                    min={this.props.properties[key].valueMeta.min}
                                    max={this.props.properties[key].valueMeta.max}
                                    value={this.props.properties[key].value}
                                    onChange={this.handleChange}/>
                                {getIssuesComponent(errors, warnings)}
                            </Col>
                            <Col sm={4} md={4} lg={4}>%</Col>
                        </Row>
                    );
                }

            });

        if (this.props.displayColors) {
            columns.push(
                <Row style={{margin: this.props.margin}}>
                    <Col sm={7} md={7} lg={7} style={{}} key={`${type}11`}>
                        <input
                            id={`${type}11`}
                            disabled
                            className={'input-property-picker'}
                            name={`${type}11`}
                            type="number"
                            min={0}
                            max={0}
                            value={0}/>
                    </Col>
                    <Col sm={4} md={4} lg={4}>%</Col>
                </Row>
            );
        }

        return columns;
    }

    render() {
        const cardBodyStyle = {
            paddingTop: '0.75rem',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-around',
            flex: 1
        };

        return (
            <div>
                <div className="flex-row">
                    <Card className="card-feature-component" style={{whiteSpace: 'nowrap'}}>
                        <div className="card-header-feature">
                            {'Output Level'}
                        </div>
                        <Card.Body className="card-body-feature" style={cardBodyStyle}>
                            {this.renderFirstRow(this.props.firstRow.property)}
                        </Card.Body>
                    </Card>
                    <Card className="card-feature-component">
                        <div className="card-header-feature">
                            {'Time'}
                        </div>
                        <Card.Body className="card-body-feature" style={cardBodyStyle}>
                            {this.renderSecondRow(this.props.secondRow.property)}
                        </Card.Body>
                    </Card>
                    <Card className="card-feature-component" style={{whiteSpace: 'nowrap'}}>
                        <div className="card-header-feature">
                            {'Sensor Level'}
                        </div>
                        <Card.Body className="card-body-feature" style={cardBodyStyle}>
                            {this.renderThirdRow(this.props.thirdRow.property)}
                        </Card.Body>
                    </Card>
                </div>

            </div>
        );
    };
}

const mapStateToProps = (state, ownProps) => {
    return {
        validationSummary: state.project.validationSummary,
        issues: state.project.issueByProperty,
    };
};

const mapDispatchToProps = {}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PropertyTableTimePickerSens);
